import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/global/Header";
import LeftNavbar from "../../components/global/LeftNavbar";
import { useTranslation } from "react-i18next";
import Select from 'react-select';

export default function VendorCreateBid() {
  const scrollRef = useRef(null);
  const { t } = useTranslation();
  const translate = t;
  
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef} tabIndex={0}>
          <div id="content" className="dashboard-wrap campaign-section">
            <nav className="breadcrumb" aria-label="breadcrumb">
              <ol>
                <li className="breadcrumb-item active" aria-current="page">
                  {translate("home")}
                </li>
              </ol>
            </nav>
            <div className="white-bg mh-550 mar-bot50">
           
              <div className="vender-edit-page">
                 <div className="vender-heading">
                   <h4>Create Bid Description Template</h4>
                 </div>
                 <div className="inner-container input-text-container">
                    <div className="flex wrap-dropdown">
                      <div className="global-dropdown-block w-d100">
                          <label>Template Name</label>
                          <input type="text" className="form-control-sm" placeholder="50 characters left" />
                      </div>
                   </div>
                   <div className="flex wrap-dropdown">
                      <div className="global-dropdown-block w-d100 mb-0">
                          <label>Template Text</label>
                          <textarea className="textarea" placeholder="3500 character limit"></textarea>
                      </div>
                  </div>
                </div>
              </div>
             
            </div>
          </div>
        </section>
      </div>
      <div className="stricy-btn flex flex-center no-rightlist">
        <div className="left flex">
            
        </div>
        <div className="left flex">
            <div>
            <button className="btn-default">Cancel</button>
            </div>
            <div>
            <button className="btn-default">Create</button>
            </div>
        </div>
     </div>
    </div>
  );
}
